module.exports = __webpack_public_path__ + "img/lowwaterpressure_attached.d7bfabbf.svg";